import { HttpClient } from "@angular/common/http"
import { TrackingEvents } from "./tracking-events"
import { Observable } from "rxjs"

export class TrackingService {

  private readonly URL: string = 'https://tracking.firefile.cc/events'

  constructor(
      private http: HttpClient
  ) {
  }

  public track(event: TrackingEvents) {
    navigator.sendBeacon(this.URL, JSON.stringify(event))
  }

  private send(event: TrackingEvents): Observable<Object> {
      return this.http.post(this.URL, event)
  }

}